import * as React from 'react'

// This union MUST stay in sync with the `icon_names=` parameter in
// /react4xp/utils/htmlTemplate.ts. Adding an icon requires updating both.
export type IconName =
    | 'keyboard_arrow_down'
    | 'arrow_right_alt'
    | 'arrow_back'
    | 'arrow_forward'
    | 'north_east'
    | 'add_2'
    | 'remove'
    | 'location_on'
    | 'search'
    | 'check'
    | 'close'
    | 'dehaze'
    | 'computer'
    | 'book_6'
    | 'forum'
    | 'assignment'
    | 'schedule'
    | 'group'

interface IconProps {
    name: IconName
    size?: number
    fill?: boolean
    className?: string
}

export const Icon: React.FC<IconProps> = ({name, size, fill = false, className}) => {
    const style: React.CSSProperties = {}
    if (size !== undefined) {
        style.fontSize = `${size}px`
    }
    if (fill) {
        style.fontVariationSettings = "'FILL' 1"
    }

    const classes = className
        ? `material-symbols-sharp ${className}`
        : 'material-symbols-sharp'

    return (
        <span
            className={classes}
            aria-hidden="true"
            style={Object.keys(style).length > 0 ? style : undefined}
        >
            {name}
        </span>
    )
}
